import { Dialog, DialogActions, DialogTitle, DialogContent, Button, Breakpoint } from '@mui/material';
import React from 'react';
import { Spinner } from './Spinner';
import { tablePrimaryButtonSx } from '../../styles/tableButtonStyles';

interface Props {
  title?: string;
  children: any;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onConfirm?: () => void;
  isValid?: boolean;
  maxWidth?: Breakpoint;
  isLoading?: boolean;
  customAction?: () => React.ReactNode;
  showSaveButton?: boolean;
}

const withModal: React.FC<Props> = (props) => {
  const { title, children, isOpen, setIsOpen, onConfirm, isValid, maxWidth, customAction, showSaveButton = true, isLoading } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      aria-labelledby='confirm-dialog'
      fullWidth={maxWidth !== undefined}
      maxWidth={maxWidth ?? 'sm'} //default is sm  // it's supported xs,sm,md,lg,xl
    >
      {isLoading && <Spinner loading={true} />}

      <DialogTitle id='confirm-dialog'>{title}</DialogTitle>
      <DialogContent>
        {/* <DialogContentText>To subscribe to this website, please enter your email address here. We will send updates occasionally.</DialogContentText> */}
        {children}
      </DialogContent>
      <DialogActions>
        {customAction ? (
          customAction()
        ) : (
          <>
            {showSaveButton && (
              <Button
                variant='contained'
                onClick={() => {
                  onConfirm?.();
                  //if (isValid) setIsOpen(false);
                }}
                color='primary'
                disabled={!isValid}
                size='small'
                sx={tablePrimaryButtonSx}
              >
                Save
              </Button>
            )}
            <Button variant='contained' onClick={() => setIsOpen(false)} color='secondary' size='small'>
              Cancel
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default withModal;
